import _ from 'underscore';

const pageGroupRegexMap = [{
  pageGroup: 'Campaigns',
  regexps: [/^campaigns$/i],
}, {
  pageGroup: 'AdDelivery',
  regexps: [
    /^ads$/i,
    /^automated-extensions$/i,
    /^action$/i,
    /^app$/i,
    /^callout$/i,
    /^image$/i,
    /^price$/i,
    /^review$/i,
    /^sitelink$/i,
    /^structuredsnippet$/i,
    /^promotion$/i,
    /^filterlink$/i,
    /^flyer$/i,
    /^video$/i,
    /^businessinfo$/i,
  ],
}, {
  pageGroup: 'Import',
  regexps: [/^import-/i],
}, {
  pageGroup: 'MerchantCenter',
  regexps: [/^mmc-/i],
}, {
  pageGroup: 'AssetManagement',
  regexps: [/asset-library/i],
}, {
  pageGroup: 'Reports',
  regexps: [/^reports-/i],
}, {
  pageGroup: 'Conversions',
  regexps: [/^uet-tag/i, /^conversion-/i, /^offline-conversions/i],
}, {
  pageGroup: 'Billing',
  regexps: [/^billing/i, /^transactions/i, /^payment/i, /^balance/i, /^insertion/i],
}];

// NOTE: This is the same as findSelectedNode in @bingads-webui/with-site-map but avoids the many peer dependencies it requires
function findSelectedNode(siteMap) {
  const currentNode = _.find(siteMap, node => _.result(node, 'selected', false));
  if (currentNode && currentNode.children) {
    const selectedChild = findSelectedNode(currentNode.children);
    if (selectedChild) {
      return selectedChild;
    }
  }
  return currentNode;
}

/**
 * Gets the current page from the site map and maps it to one of the supported page groups.
 * @param {Object} siteMap - Bing Ads site map object.
 * @returns {string} - The page group that the current page belongs to.
 */
export function mapCurrentPageToPageGroup(siteMap) {
  if (siteMap) {
    const selectedNode = findSelectedNode(siteMap);

    if (selectedNode) {
      const { id } = selectedNode;

      const matchedPageGroupRegex = _.find(pageGroupRegexMap, (pageGroupRegex) => {
        const isMatch = _.find(pageGroupRegex.regexps, r => r.test(id));

        return !!isMatch;
      });

      if (matchedPageGroupRegex) {
        return matchedPageGroupRegex.pageGroup;
      }
    }

    // selected page not in map, default to Campaigns group
    return 'Campaigns';
  }

  return 'default';
}
